module.exports = __webpack_public_path__ + "images/landing/homepage/why-image.png";